import App from './App.svelte';

let target = document.getElementById("minaraad-search-target");
if (target) {
  const app_instance = new App({
    target: target,
  });
}
